import React, { useEffect } from 'react';
import { CompetitionHero } from './competition-team/CompetitionHero';
import { CompetitionDetails } from './competition-team/CompetitionDetails';
import { CompetitionSchedule } from './competition-team/CompetitionSchedule';
import { CompetitionFinalCTA } from './competition-team/CompetitionFinalCTA';
export function CompetitionTeam() {
  useEffect(() => {
    document.title = 'Competition Team | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-823">
      <CompetitionHero data-id="element-824" />
      <CompetitionDetails data-id="element-825" />
      <CompetitionSchedule data-id="element-826" />
      <CompetitionFinalCTA data-id="element-827" />
    </div>;
}